// Smile rewards SDK loader. Loads only when user shows intent to open rewards
// (hover/focus/touch on the rewards button). Saves ~70KB for visitors who
// never tap rewards.
(function(){
  'use strict';
  var PUB_KEY = 'pub_9a306046c3812a58';
  var sdkInjected = false;
  var inited = false;

  function loadSdk(){
    if (sdkInjected) return;
    sdkInjected = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://js.smile.io/v1/smile-ui.js';
    document.head.appendChild(s);
  }

  function ensureInit(){
    if (inited) return;
    if (window.SmileUI && typeof window.SmileUI.initialize === 'function') {
      try {
        window.SmileUI.initialize({ publishableKey: PUB_KEY });
        inited = true;
      } catch(e){}
    }
  }

  document.addEventListener('smile-ui-loaded', ensureInit);

  function tryOpen(){
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      ensureInit();
      try { window.SmileUI.openPanel(); return true; } catch(e){}
    }
    return false;
  }

  // Pre-warm SDK on button intent (hover/focus/touchstart) so click feels instant
  function bindIntent(){
    var btn = document.querySelector('.floating-btn--rewards');
    if (!btn) return;
    ['pointerenter','focus','touchstart'].forEach(function(ev){
      btn.addEventListener(ev, loadSdk, { once: true, passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindIntent);
  } else {
    bindIntent();
  }

  window.openSmileRewards = function(){
    loadSdk();
    if (tryOpen()) return;
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if (tryOpen() || tries > 40) clearInterval(iv);
    }, 200);
  };
})();
